import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "workflow-use"
  }, [_c("div", {
    staticStyle: {
      padding: "10px 20px"
    }
  }, [_c("el-steps", {
    attrs: {
      active: _vm.moves.length - 1,
      "process-status": _vm.processStatus,
      "finish-status": "finish",
      "align-center": ""
    }
  }, _vm._l(_vm.moves, function (item, key) {
    return _c("el-step", {
      key: key
    }, [_c("div", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.workflowNode.label))]), _c("div", {
      attrs: {
        slot: "description"
      },
      slot: "description"
    }, [_c("div", [_vm._v("节点说明:" + _vm._s(item.workflowNode.description))]), item.operator.nickName ? _c("div", [_vm._v("操作人:" + _vm._s(item.operator.nickName))]) : _vm._e(), _c("div", [_vm._v("操作参数:" + _vm._s(item.param || "无参数"))])])]);
  }), 1)], 1), _vm.done ? _c("WorkflowInfo", {
    attrs: {
      wf: _vm.node,
      business: _vm.business,
      move: _vm.move,
      workflowMoveID: _vm.$route.query.workflowMoveID
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };